import { Component, OnInit } from '@angular/core';
import { LMSDataService } from 'lms-api';
import { Course } from 'lms-api';
import { LmsUserService } from 'lms-api';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-favorite-course-widget',
  templateUrl: './favorite-course-widget.component.html',
  styleUrls: ['./favorite-course-widget.component.scss']
})
export class FavoriteCourseWidgetComponent implements OnInit {
  public favorites: Course[];

  constructor(
    private ucdService: UserCourseDataService
  ) { }

  ngOnInit() {
    this.favorites = [];
    this.ucdService.Courses$.subscribe(courses => {
      if (courses == null) return;
      this.favorites = courses.filter(course => course.userData.Favorite);
    });
  }

}
